import * as React from 'react';
import ButtonContainer from '../ButtonContainer';
import DocumentationLink, { DocumentationLinkProps } from '../DocumentationLink';

type Props = {
    children?: React.ReactNode;
    className?: string;
    documentation?: DocumentationLinkProps;
};

export default function PageHeaderButtons({ documentation, children, className }: Props) {
    return (
        <ButtonContainer className={className}>
            {documentation && <DocumentationLink {...documentation} />}
            {children}
        </ButtonContainer>
    );
}
